<template>
	<div class="product-index pt-2">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="title">
			<div class="table-container mt-4">
				<v-row no-gutters justify="space-between" align="center">
					<h5 class="text-h6 font-weight-bold">{{ formatMonth }}</h5>
					<v-spacer />
					<v-row no-gutters justify="end">
						<v-btn color="secondary" @click="previousMonth()">
							<v-icon class="mr-1"> mdi-arrow-left </v-icon>
							先月</v-btn
						>
						<v-btn
							class="ml-2"
							color="secondary"
							@click="nextMonth()"
							:disabled="laterThanThisMonth"
						>
							翌月
							<v-icon class="mr-1"> mdi-arrow-right </v-icon>
						</v-btn>
					</v-row>
				</v-row>
				<v-data-table
					class="mt-4"
					locale="ja-JP"
					:items="inventories"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>
								{{ inventorySituation(item) }}
							</td>
							<td>
								{{ item.inventory_type_i18n ? item.inventory_type_i18n : item.type }}
							</td>
							<td class="pa-1 text-center">
								<v-btn
									color="secondary"
									v-if="inventoryBtnType(item.situation) == 'start'"
									@click="
										$router.push({
											name: 'inventory_new',
											params: { id: item.inventory_type },
											query: { month: month },
										})
									"
								>
									<v-icon class="mr-1">mdi-file-document-plus-outline</v-icon>
									実施する
								</v-btn>
								<v-btn
									color="secondary"
									v-if="inventoryBtnType(item.situation) == 'unsettled'"
									@click="
										$router.push({
											name: 'inventory_new',
											params: { id: item.inventory_type },
											query: { month: month },
										})
									"
								>
									<v-icon class="mr-1">mdi-file-document-plus-outline</v-icon>
									再開する
								</v-btn>
								<v-btn color="secondary" v-if="inventoryBtnType(item.situation) == 'null'" disabled>
									<v-icon class="mr-1">mdi-account-clock-outline</v-icon>

									実施待ち
								</v-btn>
								<v-btn
									color="secondary"
									v-if="inventoryBtnType(item.situation) == 'pending'"
									disabled
								>
									<v-icon class="mr-1">mdi-account-clock-outline</v-icon>
									承認待ち</v-btn
								>
								<v-btn
									color="secondary"
									v-if="inventoryBtnType(item.situation) == 'approve'"
									@click="$router.push({ name: 'inventory_show', params: { id: item.id } })"
								>
									<v-icon class="mr-1">mdi-eye-outline</v-icon>
									確認する</v-btn
								>
								<v-btn
									color="secondary"
									v-if="inventoryBtnType(item.situation) == 'completed'"
									@click="$router.push({ name: 'inventory_show', params: { id: item.id } })"
								>
									<v-icon class="mr-1">mdi-eye-outline</v-icon>
									結果確認</v-btn
								>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"

export default {
	components: {
		CommonFlame,
		FunctionTitle,
	},
	data() {
		return {
			title: "棚卸し項目選択",
			month: moment().format("YYYY-MM"),
			thisMonth: moment().format("YYYY-MM"),
			authority_flag: false,
			headers: [
				{
					text: "状態",
					value: "status",
					width: "100px",
				},
				{
					text: "棚卸し対象在庫",
					value: "",
					width: "200px",
				},
				{
					text: "",
					value: "btn",
					width: "100px",
					align: "center",
				},
			],
			inventories: [],
		}
	},

	mounted() {
		this.fetchSelectTarget()
	},
	methods: {
		fetchSelectTarget() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/inventories/", {
					headers,
					params: {
						month: this.month,
					},
				})
				.then((res) => {
					this.inventory_types = res.data.inventory_types
					this.setInventoriesByType(res.data.inventories)
					this.authority_flag = res.data.authority_flag
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setInventoriesByType(inventories) {
			this.inventories = this.inventory_types.map((type) => {
				let inventory = inventories.find((i) => i.inventory_type == type.value)
				if (inventory) {
					return inventory
				} else {
					return { inventory_type_i18n: type.name, inventory_type: type.value }
				}
			})
		},
		nextMonth() {
			this.month = moment(this.month).add(1, "months").format("YYYY-MM")
			this.fetchSelectTarget()
		},
		previousMonth() {
			this.month = moment(this.month).subtract(1, "months").format("YYYY-MM")
			this.fetchSelectTarget()
		},
		inventorySituation(inventory) {
			if (inventory) {
				return inventory.situation == "completed" ? "完了" : "未完了"
			} else {
				return "未完了"
			}
		},
		inventoryBtnType(situation) {
			if (!situation && this.authority_flag) {
				return "start"
			} else if (!situation) {
				return "null"
			} else if (situation == "unsettled" && this.authority_flag) {
				return "resume"
			} else if (situation == "unsettled") {
				return "null"
			} else if (situation == "pending" && this.approval_authority_flag) {
				return "approve"
			} else if (situation == "pending") {
				return "pending"
			} else if (situation == "completed") {
				return "completed"
			}
		},
	},
	computed: {
		formatMonth() {
			return moment(this.month).format("YYYY年MM月")
		},
		laterThanThisMonth() {
			return !moment(this.thisMonth).isAfter(this.month)
		},
	},
}
</script>
